import React from 'react';
import StarIcon from '@material-ui/icons/Star';
import RoomIcon from '@material-ui/icons/Room';
import lysvark from "../assets/ikon_app_lysvaerk.png";
import popup from "../assets/ikon_app_popup.png";

function LocationPin(props) {
    return(
        <div 
        // style={props.isAcive ? styling.activeOuterCircle : styling.outerCircle}
        >
            {/* {iconType(props.location.category)} */}
            <img src={iconType(props.location.category)} alt="LOGO" height="20"/>

        </div>
    )
}

const iconType = (type) => {
    const kategorier = ["Lightworks", "Events"]
    var innerColor = "blue"
    var icon = lysvark//<RoomIcon style={styling.icon} />
    switch (type) {
        case kategorier[0]:
            return lysvark
            break;
        case kategorier[1]:
            return popup
            break;
        case kategorier[2]:
            innerColor = "purple"
            icon = <RoomIcon style={styling.icon} />
            break;
        default:
            break;
    }
return lysvark
}

const styling = {
    outerCircle : { 
        height: 30, 
        width: 30, 
        // backgroundColor: "white", 
        borderRadius: 15, 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    activeOuterCircle: {
        height: 32, 
        width: 32, 
        backgroundColor: "white", 
        borderRadius: 16, 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    innerCircle : { 
        height: 28, 
        width: 28, 
        borderRadius: 14, 
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    icon : {
        color:"white", 
        height: 20, 
        width: 20
    }
}

export default LocationPin
